import { Formatter } from '.';

export class OperationalDayName {

    public static fromDto(dto: string): OperationalDayName {

        const matchResults = OperationalDayName.ISO8601Date.exec(dto);

        if (!matchResults) {
            throw new Error(`Invalid date format '${dto}'. ISO-8601 date format is expected.`);
        }

        const year = Number.parseInt(matchResults[1], 10);
        const month = Number.parseInt(matchResults[2], 10);
        const day = Number.parseInt(matchResults[3], 10);

        const date = new Date();
        date.setHours(0, 0, 0, 0);
        date.setFullYear(year, month - 1, day);

        const result = new OperationalDayName(date);

        return result;
    }
    public static compare(
        left: OperationalDayName | null | undefined,
        right: OperationalDayName | null | undefined
    ): number {

        let result: number;

        if (typeof(left) === 'undefined' && typeof(right) === 'undefined') {
            result = 0;
        } else if (typeof(left) === 'undefined') {
            result = 1;
        } else if (typeof(right) === 'undefined') {
            result = -1;
        } else

        if (left === null && right === null) {
            result = 0;
        } else if (left === null) {
            result = 1;
        } else if (right === null) {
            result = -1;
        } else {
            const lms = left._date.getTime();
            const rms = right._date.getTime();

            result = lms - rms;
        }

        return result;
    }

    private static readonly ISO8601Date: RegExp = /(?<year>\d{4})-(?<month>\d{2})-(?<day>\d{2})T.*/;

    private readonly _date: Date;

    constructor(date: Date) {
        this._date = date;
    }

    public format(formattingOptions?: Intl.DateTimeFormatOptions): string {
        const result = Formatter.dateToString(this._date, formattingOptions);
        return result;
    }

    public toDate(): Date {
        const result = new Date();
        result.setTime(this._date.getTime());
        return result;
    }

}
